/**
 * Copyright 2018-2021 Sourcepole AG
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {createSelector} from 'reselect';
import axios from 'axios';
import ConfigUtils from '../utils/ConfigUtils';
import CoordinatesUtils from '../utils/CoordinatesUtils';
import LocaleUtils from '../utils/LocaleUtils';
import MapUtils from '../utils/MapUtils';
import CopyButton from '../components/widgets/CopyButton';
import Icon from '../components/Icon';
import displayCrsSelector from '../selectors/displaycrs';
import './style/MapInfoTooltip.css';
import IdentifyUtils from '../utils/IdentifyUtils';//Ajout XM
import IdentifyViewer from '../components/IdentifyViewer';//Ajout XM
import ResizeableWindow from '../components/ResizeableWindow';//Ajout XM
import TaskBar from '../components/TaskBar';//Ajout XM

class XMparcelle extends React.Component {
    static propTypes = {
        displaycrs: PropTypes.string,
        elevationPrecision: PropTypes.number,
        //enabled: PropTypes.bool,
	currentTask: PropTypes.string,//Ajout XM
        includeWGS84: PropTypes.bool,
	//informations: PropTypes.bool,//Ajout XM
	layers: PropTypes.array,//Ajout XM
        map: PropTypes.object,
	params: PropTypes.object,//Ajout XM
	featureInfoReturnsLayerName: PropTypes.bool,
	initialHeight: PropTypes.number,
        initialWidth: PropTypes.number,
        initialX: PropTypes.number,
        initialY: PropTypes.number,
    }
    static defaultProps = {
        elevationPrecision: 0,
        includeWGS84: true,
	initialWidth: 240,
        initialHeight: 320,
        initialX: 0,
        initialY: 0,
        featureInfoReturnsLayerName: true
    }
    state = {
        coordinate: null, elevation: null, extraInfo: null, parcelles:<a href="https://geoqual.fr" target="_blank">Aucun retour</a>
    }
    fonctionauxiliaire(reponsewms) {
	let reponsepartielle = '';
	let reponseformatee = [];
	let debut = '<wfs:member>';//pour identifier plusieurs répondants au clic
	let fin = '</wfs:member>';
	let nomcommune = '';
	let surface = '';
	let numero = '';
	let debutnomcommune = '<CADASTRALPARCELS.PARCELLAIRE_EXPRESS:nom_com>';
	let finnomcommune = '</CADASTRALPARCELS.PARCELLAIRE_EXPRESS:nom_com>';
	let debutsurface = '<CADASTRALPARCELS.PARCELLAIRE_EXPRESS:contenance>';
	let finsurface = '</CADASTRALPARCELS.PARCELLAIRE_EXPRESS:contenance>';
	let debutnumero = '<CADASTRALPARCELS.PARCELLAIRE_EXPRESS:numero>';
	let finnumero = '</CADASTRALPARCELS.PARCELLAIRE_EXPRESS:numero>';
	const profondeur=200.0;//on fixe une profondeur limite de 200m - en lien avec les textes sur la minime importance
	const capacitesol=2200000.0;//en J/(m^3.K)
	const capacitesolmwh=capacitesol/3600000000.0;//Conversion en MWh/(m^3.K)
	let indice = 0;
	//window.alert(capacitesolmwh);
	//window.alert(capacitesolmwh.toFixed(2));
	while (reponsewms.indexOf(debut) > -1) {
	    reponsepartielle = reponsewms.substring(reponsewms.indexOf(debut),reponsewms.indexOf(fin)+fin.length);//extrait de reponsewms contenant les informations sur une unique parcelle
	    nomcommune = reponsepartielle.substring(reponsepartielle.indexOf(debutnomcommune)+debutnomcommune.length,reponsepartielle.indexOf(finnomcommune));
	    surface = reponsepartielle.substring(reponsepartielle.indexOf(debutsurface)+debutsurface.length,reponsepartielle.indexOf(finsurface));
	    numero = reponsepartielle.substring(reponsepartielle.indexOf(debutnumero)+debutnumero.length,reponsepartielle.indexOf(finnumero));
	    reponsewms = reponsewms.slice(reponsewms.indexOf(fin)+fin.length);
	    if (indice > 0) {
		reponseformatee.push(<br></br>);//retour à la ligne entre diverses réponses
	    }
	    reponseformatee.push(<b>Parcelle {numero}</b>);
	    reponseformatee.push(' ('+nomcommune+') : '+surface+' m^2, ');
	    reponseformatee.push(<i>soit un stock géothermique de {(capacitesolmwh*profondeur*surface).toFixed(1)} MWh/K</i>);
	    indice++;
	}
	return reponseformatee;
    }
    componentDidUpdate(prevProps, prevState) {
	if (this.props.currentTask !== prevProps.currentTask && prevProps.currentTask === "XMparcelle") {//Ajout XM issu de Identify.jsx
            this.clear();
            return;
        }
        const newPoint = this.props.map.click;
	if (!newPoint) {
            if (this.state.coordinate) {
                this.clear();
            }
        } else {
            const oldPoint = prevProps.map.click;
            if (!oldPoint || oldPoint.pixel[0] !== newPoint.pixel[0] || oldPoint.pixel[1] !== newPoint.pixel[1]) {
                this.setState({coordinate: newPoint.coordinate, elevation: null, extraInfo: false});
                const serviceParams = {pos: newPoint.coordinate.join(","), crs: this.props.map.projection};
		const center = serviceParams.pos.split(",");
		const crs = serviceParams.crs;
		const map = this.props.map;
		/*INUTILE SI ON NE SE SERT PLUS DE LA BBOX
		const size = [15, 15];
		const resolution = MapUtils.computeForZoom(map.resolutions, map.zoom);
		const dx = 0.5 * resolution * size[0];
		const dy = 0.5 * resolution * size[1];*/
		//if (!this.props.enabled) {
		if (this.props.currentTask === "XMparcelle") {
		    /*INUTILE SI ON NE SE SERT PLUS DE LA BBOX
		    let bbox = [center[0] - dx, center[1] - dy, center[0] - (0-dx), center[1] - (0-dy)];
		    if (CoordinatesUtils.getAxisOrder(map.projection).substr(0, 2) === 'ne' && version === '1.3.0') {
			bbox = [center[1] - dx, center[0] - dy, center[1] + dx, center[0] + dy];
		    }
		    bbox: bbox.join(",");*/
		    let point = [center[0] , center[1]];
		    if (CoordinatesUtils.getAxisOrder(map.projection).substr(0, 2) === 'ne' && version === '1.3.0') {
			point = [center[1] , center[0]];
		    }
		    let pointabscisse = point[0];
		    let pointordonnee = point[1];
		    const urlparcelle='https://wxs.ign.fr/essentiels/geoportail/wfs';
		    const params={
			service: 'WFS',
			version: '2.0.0',
			request: 'GetFeature',
			typename: 'CADASTRALPARCELS.PARCELLAIRE_EXPRESS:parcelle',
			count: '10',
			srsName: 'EPSG:2154',
			//srsName: 'EPSG:4326',
			//bbox: bbox+','+crs//BBOX n'est pas le mieux adapté ici
		    };
		    //const urlcomplete=urlparcelle+'?SERVICE='+params.service+'&VERSION='+params.version+'&REQUEST='+params.request+'&TYPENAME='+params.typename+'&COUNT='+params.count+'&SRSNAME='+params.srsName+'&BBOX='+params.bbox;//BBOX n'est pas le mieux adapté ici
		    const urlcomplete=urlparcelle+'?SERVICE='+params.service+'&VERSION='+params.version+'&REQUEST='+params.request+'&TYPENAME='+params.typename+'&COUNT='+params.count+'&SRSNAME='+params.srsName+'&CQL_FILTER=INTERSECTS(the_geom,SRID='+crs.substr(5)+';POINT('+pointabscisse+' '+pointordonnee+'))';
		    //window.alert(urlcomplete);
		    fetch(urlcomplete)
			.then(response => { return response.text(); })
			.then(content => {
			    //window.alert(content);
			    let reponse = this.fonctionauxiliaire(content);
			    this.setState({parcelles: reponse});//Ce qui sera affiché dans le panneau
			    this.setState({extraInfo: true});//C'est ce qui permettra d'ouvrir le panneau (avec les retours de la fonction auxiliaire)
			    //window.alert('Informations : '+this.state.extraInfo+' avec '+reponse);
			})
		 }
            }
        }
    }
    clear = () => {
        this.setState({coordinate: null, height: null, extraInfo: null});
    }
    onShow = () => {
    }
    onToolClose = () => {
        this.setState({extraInfo: false});
    }
    clearResults = () => {
        this.setState({extraInfo: false});
    }
    render() {
        //return null;
	let resultWindow = null;
	if (this.state.extraInfo) {
	    let body = (<div className="identify-body" role="body"><span className="identify-body-message">{this.state.parcelles}</span></div>);
	    resultWindow = (
                <ResizeableWindow icon="info-sign"
                    initialHeight={this.props.initialHeight} initialWidth={this.props.initialWidth}
                    initialX={this.props.initialX} initialY={this.props.initialY} initiallyDocked={this.props.initiallyDocked}
                    key="IdentifyWindow"
                    onClose={this.clearResults} title={LocaleUtils.trmsg("identify.title")}
                >
		    {body}
                </ResizeableWindow>
            );
	}
	return [resultWindow, (
            <TaskBar key="IdentifyTaskBar" onHide={this.onToolClose} onShow={this.onShow} task="Identify">
                {() => ({
                    //body: this.state.mode === "Region" ? LocaleUtils.tr("infotool.clickhelpPolygon") : LocaleUtils.tr("infotool.clickhelpPoint")
                })}
            </TaskBar>
        )];
    }  
}

const selector = createSelector([state => state, displayCrsSelector], (state, displaycrs) => ({
    //enabled: state.identify.tool !== null,
    currentTask: state.task.id,//Ajout XM issu de Identify.jsx
    layers: state.layers.flat,
    map: state.map,
    displaycrs: displaycrs
}));

export default connect(selector, {})(XMparcelle);
